<template>
  <div v-if="response !== null">
    <document-container
        :body="[]"
        :footer="[]"

        documentType="portfolio"
        orientation="portrait"
    >
      <template #raw-header>
        <header class="raw-header">
          <div class="header-disclaimer">
            <strong>WERBEMITTEILUNG</strong>
            <div style="top:6px;position:relative">
              {{ response.portfolioName }}
            </div>
          </div>
          <img
              :src="logo" alt="" class="logo">
        </header>
      </template>
      <div
          slot="raw-body"
          class="page-block "
      >
        <div class="heading">
          <h1>PORTFOLIO SIMULATION</h1>
          <h2>IHR PORTFOLIOVORSCHLAG IM ÜBERBLICK</h2>
        </div>
        <div class="page-disclaimer">
          Rechtliche Hinweise:
          <br> Diese Information ist als Werbung im Sinne des Wertpapierhandelsgesetzes und der EU-Prospektverordnung anzusehen. Das heißt, sie genügt nicht den rechtlichen Anforderungen für Finanzinstrumente und Vermögensanlagen. Es handelt sich um die unveränderte Weitergabe einer Marktidee bzw. einer sonstigen Marktinformation durch die Sie betreuende Sparkasse. Bezüglich weiterer Informationen sowie der Offenlegung möglicher Interessenkonflikte wird auf die Homepage Ihrer Sparkasse verwiesen. Die Publikation stellt keine Anlageberatung oder Handlungsempfehlung in Bezug auf die genannten Finanzinstrumente bzw. Vermögensanlagen seitens der Sparkasse dar. Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.
          <br> Die genannten Finanzinstrumente bzw. Vermögensanlagen werden lediglich in Kurzform beschrieben. Eine Anlageentscheidung sollte nur auf Grundlage der Informationen in den rechtlich verbindlichen Dokumenten wie dem Wertpapier- oder Verkaufsprospekt, den Endgültigen Bedingungen, dem Basisinformationsblatt und den Jahres- bzw. Halbjahresberichten der Vermögensanlagen erfolgen, die Sie bei Ihrer Sparkasse, auf Verlangen in Papierform, kostenlos erhalten.
        </div>
      </div>
      <div
          slot="raw-footer"
          class="page-block"
      >
        <div class="disclaimer-date">
          Erstellt am {{ $options.filters.date(new Date(), 'DD.MM.YYYY HH:mm') }}
        </div>
      </div>
    </document-container>
    <document-container
        :body="[]"
        :footer="[]"

        :header="[{
          type: 'Pagetitle',
          title: 'Aufteilung',
          position: 'header',
          sort: 1,
          shared: true,
        }]"
        :logo="logo"
        documentType="portfolio"
        orientation="portrait"
    >
      <div
          slot="raw-body"
          class="page-block">
        <h3>Portfoliostruktur</h3>

        <table
            class="allocation-table">
          <tr>
            <td style="width:350px">
              <table class="product-table">
                <tr v-if="Object.values(response.coreInvestmentDistribution).length !==0" class="allocation-heading">
                  <td>Kernanlage</td>
                  <td v-html="formatPercent(Object.values(response.coreInvestmentDistribution).reduce((el, sum) => sum + el), 0)"></td>
                </tr>
                <tr v-for="(el, key, index) in response.coreInvestmentDistribution" v-if="Object.values(response.coreInvestmentDistribution).length !==0">
                  <td>
                    <div style="display: inline-block; vertical-align: top;width:10px;margin-right:10px">
                      <span :style="{backgroundColor: colors[index]}" class="dot"></span>
                    </div>
                    <div style="display: inline-block; vertical-align: top; width:235px">{{ key }}</div>
                  </td>
                  <td v-html="formatPercent(el, 0)"></td>
                </tr>
                <tr v-if="Object.values(response.satelliteInvestmentDistribution).length !==0" class="allocation-heading">
                  <td>Satellitenanlage</td>
                  <td v-html="formatPercent(Object.values(response.satelliteInvestmentDistribution).reduce((el, sum) => sum + el), 0)"></td>
                </tr>

                <tr v-for="(el, key, index) in response.satelliteInvestmentDistribution" v-if="Object.values(response.satelliteInvestmentDistribution).length !==0">
                  <td>
                    <div style="display: inline-block; vertical-align: top;width:10px;margin-right:10px">
                      <span :style="{backgroundColor: colors[index + Object.values(response.coreInvestmentDistribution).length]}" class="dot"></span>
                    </div>
                    <div style="display: inline-block; vertical-align: top; width:235px">{{ key }}</div>
                  </td>
                  <td v-html="formatPercent(el, 0)"></td>

                </tr>
              </table>
            </td>
            <td style="padding: 1px 0 0 0">
              <chart-container
                  v-if="chartData"
                  :chart-data="chartData.donut1"
                  :settings="{style: {height: 130,width: 130}}"
                  chart-type="ChartDoughnut"
              ></chart-container>
            </td>
          </tr>
        </table>
      </div>
      <div
          slot="raw-body"
          class="page-block">
        <h3>Vermögensaufteilung</h3>

        <table
            class="allocation-table">
          <tr>
            <td style="width:350px">
              <table class="product-table">
                <tr v-for="(el, key, index) in response.assetDistribution">
                  <td>

                    <div style="display: inline-block; vertical-align: top;width:10px;margin-right:10px">
                      <span :style="{backgroundColor: colors[index]}" class="dot"></span>
                    </div>
                    <div style="display: inline-block; vertical-align: top; width:235px">{{ key }}</div>

                  </td>
                  <td v-html="formatPercent(el, 0)"></td>

                </tr>
              </table>
            </td>
            <td style="padding: 1px 0 0 0">
              <chart-container
                  v-if="chartData"
                  :chart-data="chartData.donut2"
                  :settings="{style: {height: 130,width: 130}}"
                  chart-type="ChartDoughnut"
              ></chart-container>
            </td>
          </tr>
        </table>
      </div>
      <div
          slot="raw-body"
          class="page-block">
        <h3>Währungsaufteilung</h3>

        <table
            class="allocation-table">
          <tr>
            <td style="width:350px">
              <table class="product-table">
                <tr v-for="(el, key, index) in response.currencyDistribution">
                  <td>

                    <div style="display: inline-block; vertical-align: top;width:10px;margin-right:10px">
                      <span :style="{backgroundColor: colors[index]}" class="dot"></span>
                    </div>
                    <div style="display: inline-block; vertical-align: top; width:235px">{{ key }}</div>

                  </td>
                  <td v-if="el >= .01" v-html="formatPercent(el, 0)"></td>
                  <td v-else><1 %</td>

                </tr>
              </table>
            </td>
            <td style="padding: 1px 0 0 0">
              <chart-container
                  v-if="chartData"
                  :chart-data="chartData.donut3"
                  :settings="{style: {height: 130,width: 130}}"
                  chart-type="ChartDoughnut"
              ></chart-container>
            </td>
          </tr>
        </table>
      </div>
      <div
          slot="raw-body"
          class="page-block"
      >

        <div class="page-disclaimer">
          <div v-if="Object.keys(response.assetDistribution).includes('Mischprodukte*')">
            * Die Gewichtung der einzelnen Vermögensaufteilung kann höher sein als dargestellt, da sie auch in den Mischfonds enthalten sind.
          </div>
          <br> Rechtsdokumente finden Sie im Wertpapiervergleich am Ende des Dokumentes.
          <br>
          <br>

          Quelle Fondsdaten: FE Fundinfo Limited
          <br> Quelle Berechnung Datenaggregation: Dericon GmbH
          <br> Die angegebene Vermögensaufteilung bezieht sich auf die Klassifizierungen der Fonds beispielsweise als Aktien-. Renten-, Immobilienfonds. Sie bezieht sich nicht auf die in den jeweiligen Fonds enthaltenen Vermögenswerte. Die angegebene Währungsaufteilung bezieht sich auf die Fondswährungen und nicht auf die in den jeweiligen Fonds enthaltenen Vermögenswerte.
          <br> Bitte beachten Sie: Die Auswahl der dargestellten Investments und Angaben zu deren Gewichtung basieren auf Vorgaben der Sie betreuenden Sparkasse.
        </div>

        <div
            slot="raw-footer"
            class="page-block"
        >
          <div class="disclaimer-date">
            Erstellt am {{ $options.filters.date(new Date(), 'DD.MM.YYYY HH:mm') }}
          </div>
        </div>
      </div>
    </document-container>
    <document-container
        :body="[]"
        :footer="[]"

        :header="[{
          type: 'Pagetitle',
          title: 'Wertentwicklung',
          position: 'header',
          sort: 1,
          shared: true,
        }]"
        :logo="logo"
        documentType="portfolio"
        orientation="portrait"
    >
      <div
          slot="raw-body"
          class="page-block"
      >
        <chart-container
            :chartData="developmentChart"
            :chartType="'ChartPortfolioHistory'"
            :settings="{
              style: {
                width: 520,
                height: 195
              }
            }"
        ></chart-container>
        <div class="tiny-text" style="margin-top:12px; margin-bottom: 24px">Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.</div>
      </div>
      <div
          slot="raw-body"
          class="page-block">

        <h3>Performance (absolut / p.a.)</h3>

        <table class="product-table development-table">
          <tr>
            <th style="width:150px">
              <strong>Werte für</strong>
            </th>
            <th v-for="(val, key, index) in performanceMap">
              <strong>{{ val }}</strong>
              <br>
              <DocTimeFrame :years="key"/>
            </th>
          </tr>
          <tr v-for="(row,key) in [...portfolioFigures,...coreFigures,...satelliteFigures]">
            <td>

              <div style="display: inline-block; vertical-align: top;width:10px;margin-right:10px">
                <span :style="{backgroundColor: colors[key]}" class="dot"></span>
              </div>
              <div style="display: inline-block; vertical-align: top; width:118px">
                <strong>{{ getGroupName(row.id.type, row.id.name) }} </strong>
              </div>


            </td>
            <td v-for="(val,key) in performanceMap">
              {{ formatPercent(row.performance[key]) }}<br> / {{ formatPercent(row.annualizedPerformance[key]) }}
            </td>
          </tr>
        </table>

      </div>
      <div
          slot="raw-body"
          class="page-block">

        <h3>Volatilität</h3>

        <table class="product-table development-table">
          <tr>
            <th style="width:150px">
              <strong>Werte für</strong>
            </th>
            <th v-for="(val, key, index) in performanceMap">
              <strong>{{ val }}</strong>
              <br>
              <DocTimeFrame :years="key"/>

            </th>
          </tr>
          <tr v-for="(row,key) in [...portfolioFigures,...coreFigures,...satelliteFigures]">

            <td>

              <div style="display: inline-block; vertical-align: top; width:118px">
                <strong>{{ getGroupName(row.id.type, row.id.name) }} </strong>
              </div>
            </td>
            <td v-for="(val,key) in performanceMap">
              {{ formatPercent(row.volatility[key]) }}
            </td>
          </tr>
        </table>

      </div>
      <div
          slot="raw-body"
          class="page-block"
      >
        <div class="tiny-text">Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.</div>
        <div class="page-disclaimer">
          Transaktionskosten, Provisionen, Depotkosten und Steuern sind in der Berechnung nicht berücksichtigt und würden sich bei Berücksichtigung negativ auf die Wertentwicklung auswirken. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten. Diese Kostendarstellung erfüllt damit nicht die Anforderungen an einen aufsichtsrechtlich vorgeschriebenen Kostenausweis (ex post bzw. ex ante), den Sie rechtzeitig vor Auftragsausführung erhalten werden. Alle Fragen zu entstehenden Kosten werden Ihnen von Ihrer Sparkasse beantwortet.
          <br>Sollten für einzelne Fonds keine Kursdaten über den gesamten angezeigten Zeitraum vorhanden sein, werden diese Fonds für die Berechnung der Wertentwicklungen für die betreffenden Zeiträume nicht berücksichtigt und die Gewichtung der anderen Fonds entsprechend angepasst.
          <br>Risikohinweis: Jede Anlage in Finanzinstrumenten bzw. Vermögensanlagen ist mit Risiken verbunden. Die Anlage ist nicht garantiert, Schwankungen des Marktes können zu Kursverlusten bis hin zum Totalverlust des eingesetzten Kapitals führen. Über die speziellen Risiken des jeweiligen Finanzinstruments bzw. der Vermögensanlage informieren Sie ihre Sparkassen-Berater und die jeweiligen gesetzlich vorgeschriebenen Verkaufsunterlagen. Einen link zu den Verkaufsunterlagen finden Sie auf der Seite „Wertpapiervergleich“ an Ende des Dokuments. Die Verkaufsunterlagen sind auch in der Sparkassen-Filiale bei ihren Beratern erhältlich.
          <br>
          <br>Datenbasis: Tagesdaten des dargestellten Zeitraums, Quelle: FWW Fundservices GmbH, Dericon GmbH
          <br>Bei der Berechnung der Wertentwicklungen werden keine kundenindividuellen Kosten wie Depotkosten oder Transaktionskosten berücksichtigt. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten.
        </div>
      </div>

      <div
          slot="raw-footer"
          class="page-block"
      >
        <div class="disclaimer-date">
          Erstellt am {{ $options.filters.date(new Date(), 'DD.MM.YYYY HH:mm') }}
        </div>
      </div>
    </document-container>
    <document-container
        :body="[]"
        :footer="[]"

        :header="[{
          type: 'Pagetitle',
          title: 'Wertentwicklung',
          position: 'header',
          sort: 1,
          shared: true,
        }]"
        :logo="logo"
        documentType="portfolio"
        orientation="portrait"
    >
      <div
          slot="raw-body"
          class="page-block"
      >
        <h3>Größter Verlust</h3>

        <table class="product-table development-table">
          <tr>
            <th style="width:150px">
              <strong>Werte für</strong>
            </th>
            <th v-for="val in maxDrawdownMap">
              <strong>{{ val }}</strong>
            </th>
          </tr>
          <tr v-for="(row,key)  in [...portfolioFigures,...coreFigures,...satelliteFigures]" v-if="row.maxDrawdown !== null">
            <td>
              <div style="display: inline-block; vertical-align: top; width:118px">
                <strong>{{ getGroupName(row.id.type, row.id.name) }} </strong>
              </div>
            </td>
            <td>
              {{ formatPercent(row.maxDrawdown.relativeLoss) }}
            </td>
            <td>
              {{ formatDays(row.maxDrawdown.lossPeriodInDays) }}
            </td>
            <td>
              {{ $options.filters.date(row.maxDrawdown.periodStart) }}
            </td>
            <td>
              {{ $options.filters.date(row.maxDrawdown.periodEnd) }}
            </td>
            <td>
              {{ formatDays(row.maxDrawdown.timeToRecoverInDays) }}
            </td>
          </tr>
        </table>
        <div class="tiny-text" style="margin-top:12px">Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.</div>

      </div>

      <div
          slot="raw-body"
          class="page-block">
        <h3>Rollierende Wertentwicklung über 5 Jahre</h3>
      </div>

      <div
          slot="raw-body"
          class="page-block">
        <table class="product-table development-table">
          <tr>
            <th style="width:150px">
              <strong>Werte für</strong>
            </th>
            <th v-for="val in portfolioFigures[0].yearlyReturns" style="width:69px">
              <strong>{{ $options.filters.date(val.startDate, 'DD.MM.YY') }}</strong><br><strong>–&nbsp;{{ $options.filters.date(val.endDate, 'DD.MM.YY') }}</strong>
            </th>
          </tr>
          <tr>
            <td style="width:150px">
              <strong>Portfolio</strong>
            </td>
            <td v-for="val in portfolioFigures[0].yearlyReturns" style="width:69px">
              <strong>{{ formatPercent(val.performance) }}</strong>
            </td>
          </tr>
        </table>
      </div>

      <div
          slot="raw-body"
          class="page-block">
        <table class="product-table development-table">
          <!--          <tr>-->
          <!--            <th style="width:150px">-->
          <!--              <strong>Werte für</strong>-->
          <!--            </th>-->
          <!--            <th v-for="val in portfolioFigures[0].yearlyReturns">-->
          <!--              <strong>{{ $options.filters.date(val.startDate, 'DD.MM.YY') }}</strong><br><strong>–&nbsp;{{ $options.filters.date(val.endDate, 'DD.MM.YY') }}</strong>-->
          <!--            </th>-->
          <!--          </tr>-->
          <tr v-if="coreFigures.length > 0">
            <td style="width:150px">
              <strong>Kernanlage</strong>
            </td>
            <td v-for="val in coreFigures[0].yearlyReturns" style="width:69px">
              <strong>{{ formatPercent(val.performance) }}</strong>
            </td>
          </tr>
          <tr v-for="product in productFigures.filter(el => el.id.identifier.indexOf('CORE') !== -1)">
            <td style="width:150px">
              {{ product.id.name }}
            </td>
            <td v-for="val in product.yearlyReturns" style="width:69px">
              {{ formatPercent(val.performance) }}
            </td>
          </tr>
        </table>
      </div>

      <div
          slot="raw-body"
          class="page-block">
        <table class="product-table development-table">
          <!--          <tr>-->
          <!--            <th style="width:150px">-->
          <!--              <strong>Werte für</strong>-->
          <!--            </th>-->
          <!--            <th v-for="val in portfolioFigures[0].yearlyReturns">-->
          <!--              <strong>{{ $options.filters.date(val.startDate, 'DD.MM.YY') }}</strong><br><strong>–&nbsp;{{ $options.filters.date(val.endDate, 'DD.MM.YY') }}</strong>-->
          <!--            </th>-->
          <!--          </tr>-->
          <tr v-if="satelliteFigures.length > 0">
            <td style="width:150px">
              <strong>Satellitenanlage</strong>
            </td>
            <td v-for="val in satelliteFigures[0].yearlyReturns">
              <strong>{{ formatPercent(val.performance) }}</strong>
            </td>
          </tr>
          <tr v-for="product in productFigures.filter(el => el.id.identifier.indexOf('SATELLITE') !== -1)">
            <td style="width:150px">
              {{ product.id.name }}
            </td>
            <td v-for="val in product.yearlyReturns" style="width:69px">
              {{ formatPercent(val.performance) }}
            </td>
          </tr>
        </table>
        <div class="tiny-text" style="margin-top:12px">Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.</div>

      </div>

      <div
          slot="raw-body"
          class="page-block">
        <div class="page-disclaimer">
          Transaktionskosten, Provisionen, Depotkosten und Steuern sind in der Berechnung nicht berücksichtigt und würden sich bei Berücksichtigung negativ auf die Wertentwicklung auswirken. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten. Diese Kostendarstellung erfüllt damit nicht die Anforderungen an einen aufsichtsrechtlich vorgeschriebenen Kostenausweis (ex post bzw. ex ante), den Sie rechtzeitig vor Auftragsausführung erhalten werden. Alle Fragen zu entstehenden Kosten werden Ihnen von Ihrer Sparkasse beantwortet.
          <br>Sollten für einzelne Fonds keine Kursdaten über den gesamten angezeigten Zeitraum vorhanden sein, werden diese Fonds für die Berechnung der Wertentwicklungen für die betreffenden Zeiträume nicht berücksichtigt und die Gewichtung der anderen Fonds entsprechend angepasst.
          <br>Risikohinweis: Jede Anlage in Finanzinstrumenten bzw. Vermögensanlagen ist mit Risiken verbunden. Die Anlage ist nicht garantiert, Schwankungen des Marktes können zu Kursverlusten bis hin zum Totalverlust des eingesetzten Kapitals führen. Über die speziellen Risiken des jeweiligen Finanzinstruments bzw. der Vermögensanlage informieren Sie ihre Sparkassen-Berater und die jeweiligen gesetzlich vorgeschriebenen Verkaufsunterlagen. Einen link zu den Verkaufsunterlagen finden Sie auf der Seite „Wertpapiervergleich“ an Ende des Dokuments. Die Verkaufsunterlagen sind auch in der Sparkassen-Filiale bei ihren Beratern erhältlich.
          <br>
          <br>Datenbasis: Tagesdaten des dargestellten Zeitraums, Quelle: FWW Fundservices GmbH, Dericon GmbH
          <br>Bei der Berechnung der Wertentwicklungen werden keine kundenindividuellen Kosten wie Depotkosten oder Transaktionskosten berücksichtigt. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten.
        </div>
      </div>
      <div
          slot="raw-footer"
          class="page-block"
      >
        <div class="disclaimer-date">
          Erstellt am {{ $options.filters.date(new Date(), 'DD.MM.YYYY HH:mm') }}
        </div>
      </div>
    </document-container>
    <document-container
        v-if="benchmarkFigures.length !== 0"
        :body="[]"

        :footer="[]"
        :header="[{
          type: 'Pagetitle',
          title: 'Portfolio vs. Benchmark',
          position: 'header',
          sort: 1,
          shared: true,
        }]"
        :logo="logo"
        documentType="portfolio"
        orientation="portrait"
    >
      <div
          slot="raw-body"
          class="page-block"
      >
        <chart-container
            :chartData="benchmarkChart"
            :chartType="'ChartPortfolioHistory'"
            :settings="{
              style: {
                width: 520,
                height: 195
              }
            }"
        ></chart-container>
        <div class="tiny-text" style="margin-top:12px; margin-bottom: 24px">Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.</div>

        <chart-container
            v-if="reducedPortfolioAndBenchmarkChart"
            :chartData="reducedPortfolioAndBenchmarkChart"
            :chartType="'ChartPortfolioHistory'"
            :settings="{
              style: {
                width: 520,
                height: 195
              }
            }"
        ></chart-container>
        <div v-if="reducedPortfolioAndBenchmarkChart"
             class="tiny-text"
             style="margin-top:12px">Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.
        </div>

      </div>

      <div v-if="reducedPortfolioAndBenchmarkChart"
           slot="raw-body"
           class="page-block">
        <div class="page-disclaimer">
          Transaktionskosten, Provisionen, Depotkosten und Steuern sind in der Berechnung nicht berücksichtigt und würden sich bei Berücksichtigung negativ auf die Wertentwicklung auswirken. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten. Diese Kostendarstellung erfüllt damit nicht die Anforderungen an einen aufsichtsrechtlich vorgeschriebenen Kostenausweis (ex post bzw. ex ante), den Sie rechtzeitig vor Auftragsausführung erhalten werden. Alle Fragen zu entstehenden Kosten werden Ihnen von Ihrer Sparkasse beantwortet.
          <br>Sollten für einzelne Fonds keine Kursdaten über den gesamten angezeigten Zeitraum vorhanden sein, werden diese Fonds für die Berechnung der Wertentwicklungen für die betreffenden Zeiträume nicht berücksichtigt und die Gewichtung der anderen Fonds entsprechend angepasst.
          <br>Risikohinweis: Jede Anlage in Finanzinstrumenten bzw. Vermögensanlagen ist mit Risiken verbunden. Die Anlage ist nicht garantiert, Schwankungen des Marktes können zu Kursverlusten bis hin zum Totalverlust des eingesetzten Kapitals führen. Über die speziellen Risiken des jeweiligen Finanzinstruments bzw. der Vermögensanlage informieren Sie ihre Sparkassen-Berater und die jeweiligen gesetzlich vorgeschriebenen Verkaufsunterlagen. Einen link zu den Verkaufsunterlagen finden Sie auf der Seite „Wertpapiervergleich“ an Ende des Dokuments. Die Verkaufsunterlagen sind auch in der Sparkassen-Filiale bei ihren Beratern erhältlich.
          <br>
          <br>Datenbasis: Tagesdaten des dargestellten Zeitraums, Quelle: FWW Fundservices GmbH, Dericon GmbH
          <br>Bei der Berechnung der Wertentwicklungen werden keine kundenindividuellen Kosten wie Depotkosten oder Transaktionskosten berücksichtigt. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten.
        </div>
      </div>
      <div
          v-if="reducedPortfolioAndBenchmarkChart"
          slot="raw-body"
          class="page-block"
      >
        <pagebreak></pagebreak>
      </div>
      <div
          slot="raw-body"
          class="page-block"
      >

        <h3>Performance (absolut / p.a.)</h3>

        <table class="product-table development-table">
          <tr>
            <th style="width:150px">
              <strong>Werte für</strong>
            </th>
            <th v-for="(val, key, index)  in performanceMap">
              <strong>{{ val }}</strong>
              <br>
              <DocTimeFrame :years="key"/>

            </th>
          </tr>
          <tr v-for="(row,key) in [...portfolioFigures,...benchmarkFigures]">
            <td>

              <div style="display: inline-block; vertical-align: top;width:10px;margin-right:10px">
                <span :style="{backgroundColor: colors[key]}" class="dot"></span>
              </div>
              <div style="display: inline-block; vertical-align: top; width:118px">
                <strong>{{ getGroupName(row.id.type, row.id.name) }} </strong>
              </div>
            </td>
            <td v-for="(val,key) in performanceMap">
              {{ formatPercent(row.performance[key]) }}<br> / {{ formatPercent(row.annualizedPerformance[key]) }}
            </td>
          </tr>
        </table>

      </div>
      <div
          slot="raw-body"
          class="page-block">

        <h3>Volatilität</h3>

        <table class="product-table development-table">
          <tr>
            <th style="width:150px">
              <strong>Werte für</strong>
            </th>
            <th v-for="(val, key, index)  in performanceMap">
              <strong>{{ val }}</strong>
              <br>
              <DocTimeFrame :years="key"/>

            </th>
          </tr>
          <tr v-for="(row,key) in [...portfolioFigures,...benchmarkFigures]">

            <td>

              <div style="display: inline-block; vertical-align: top; width:118px">
                <strong>{{ getGroupName(row.id.type, row.id.name) }} </strong>
              </div>
            </td>
            <td v-for="(val,key) in performanceMap">
              {{ formatPercent(row.volatility[key]) }}
            </td>
          </tr>
        </table>

      </div>
      <div
          v-if="reducedPortfolioAndBenchmarkChart"
          slot="raw-body"
          class="page-block">
        <h3>Größter Verlust</h3>

        <table class="product-table development-table">
          <tr>
            <th style="width:150px">
              <strong>Werte für</strong>
            </th>
            <th v-for="val in maxDrawdownMap">
              <strong>{{ val }}</strong>
            </th>
          </tr>
          <tr v-for="(row,key)  in [...portfolioFigures,...benchmarkFigures]" v-if="row.maxDrawdown !== null">
            <td>
              <div style="display: inline-block; vertical-align: top; width:118px">
                <strong>{{ getGroupName(row.id.type, row.id.name) }} </strong>
              </div>
            </td>
            <td>
              {{ formatPercent(row.maxDrawdown.relativeLoss) }}
            </td>
            <td>
              {{ formatDays(row.maxDrawdown.lossPeriodInDays) }}
            </td>
            <td>
              {{ $options.filters.date(row.maxDrawdown.periodStart) }}
            </td>
            <td>
              {{ $options.filters.date(row.maxDrawdown.periodEnd) }}
            </td>
            <td>
              {{ formatDays(row.maxDrawdown.timeToRecoverInDays) }}
            </td>
          </tr>
        </table>
      </div>


      <div
          slot="raw-body"
          class="page-block">
        <div class="tiny-text">Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.</div>

      </div>
      <div
          slot="raw-body"
          class="page-block">
        <div class="page-disclaimer">
          Transaktionskosten, Provisionen, Depotkosten und Steuern sind in der Berechnung nicht berücksichtigt und würden sich bei Berücksichtigung negativ auf die Wertentwicklung auswirken. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten. Diese Kostendarstellung erfüllt damit nicht die Anforderungen an einen aufsichtsrechtlich vorgeschriebenen Kostenausweis (ex post bzw. ex ante), den Sie rechtzeitig vor Auftragsausführung erhalten werden. Alle Fragen zu entstehenden Kosten werden Ihnen von Ihrer Sparkasse beantwortet.
          <br>Sollten für einzelne Fonds keine Kursdaten über den gesamten angezeigten Zeitraum vorhanden sein, werden diese Fonds für die Berechnung der Wertentwicklungen für die betreffenden Zeiträume nicht berücksichtigt und die Gewichtung der anderen Fonds entsprechend angepasst.
          <br>Risikohinweis: Jede Anlage in Finanzinstrumenten bzw. Vermögensanlagen ist mit Risiken verbunden. Die Anlage ist nicht garantiert, Schwankungen des Marktes können zu Kursverlusten bis hin zum Totalverlust des eingesetzten Kapitals führen. Über die speziellen Risiken des jeweiligen Finanzinstruments bzw. der Vermögensanlage informieren Sie ihre Sparkassen-Berater und die jeweiligen gesetzlich vorgeschriebenen Verkaufsunterlagen. Einen link zu den Verkaufsunterlagen finden Sie auf der Seite „Wertpapiervergleich“ an Ende des Dokuments. Die Verkaufsunterlagen sind auch in der Sparkassen-Filiale bei ihren Beratern erhältlich.
          <br>
          <br>Datenbasis: Tagesdaten des dargestellten Zeitraums, Quelle: FWW Fundservices GmbH, Dericon GmbH
          <br>Bei der Berechnung der Wertentwicklungen werden keine kundenindividuellen Kosten wie Depotkosten oder Transaktionskosten berücksichtigt. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten.
        </div>
      </div>

      <div
          slot="raw-footer"
          class="page-block"
      >
        <div class="disclaimer-date">
          Erstellt am {{ $options.filters.date(new Date(), 'DD.MM.YYYY HH:mm') }}
        </div>
      </div>
    </document-container>
    <document-container
        v-if="benchmarkFigures.length !== 0 && !reducedPortfolioAndBenchmarkChart"
        :body="[]"

        :footer="[]"
        :header="[{
          type: 'Pagetitle',
          title: 'Portfolio vs. Benchmark',
          position: 'header',
          sort: 1,
          shared: true,
        }]"
        :logo="logo"
        documentType="portfolio"
        orientation="portrait"
    >
      <div
          slot="raw-body"
          class="page-block">
        <h3>Größter Verlust</h3>

        <table class="product-table development-table">
          <tr>
            <th style="width:150px">
              <strong>Werte für</strong>
            </th>
            <th v-for="val in maxDrawdownMap">
              <strong>{{ val }}</strong>
            </th>
          </tr>
          <tr v-for="(row,key)  in [...portfolioFigures,...benchmarkFigures]" v-if="row.maxDrawdown !== null">
            <td>
              <div style="display: inline-block; vertical-align: top; width:118px">
                <strong>{{ getGroupName(row.id.type, row.id.name) }} </strong>
              </div>
            </td>
            <td>
              {{ formatPercent(row.maxDrawdown.relativeLoss) }}
            </td>
            <td>
              {{ formatDays(row.maxDrawdown.lossPeriodInDays) }}
            </td>
            <td>
              {{ $options.filters.date(row.maxDrawdown.periodStart) }}
            </td>
            <td>
              {{ $options.filters.date(row.maxDrawdown.periodEnd) }}
            </td>
            <td>
              {{ formatDays(row.maxDrawdown.timeToRecoverInDays) }}
            </td>
          </tr>
        </table>
        <div class="tiny-text" style="margin-top:12px">Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.</div>
      </div>
      <div
          slot="raw-body"
          class="page-block">
        <div class="page-disclaimer">
          Transaktionskosten, Provisionen, Depotkosten und Steuern sind in der Berechnung nicht berücksichtigt und würden sich bei Berücksichtigung negativ auf die Wertentwicklung auswirken. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten. Diese Kostendarstellung erfüllt damit nicht die Anforderungen an einen aufsichtsrechtlich vorgeschriebenen Kostenausweis (ex post bzw. ex ante), den Sie rechtzeitig vor Auftragsausführung erhalten werden. Alle Fragen zu entstehenden Kosten werden Ihnen von Ihrer Sparkasse beantwortet.
          <br>Sollten für einzelne Fonds keine Kursdaten über den gesamten angezeigten Zeitraum vorhanden sein, werden diese Fonds für die Berechnung der Wertentwicklungen für die betreffenden Zeiträume nicht berücksichtigt und die Gewichtung der anderen Fonds entsprechend angepasst.
          <br>Risikohinweis: Jede Anlage in Finanzinstrumenten bzw. Vermögensanlagen ist mit Risiken verbunden. Die Anlage ist nicht garantiert, Schwankungen des Marktes können zu Kursverlusten bis hin zum Totalverlust des eingesetzten Kapitals führen. Über die speziellen Risiken des jeweiligen Finanzinstruments bzw. der Vermögensanlage informieren Sie ihre Sparkassen-Berater und die jeweiligen gesetzlich vorgeschriebenen Verkaufsunterlagen. Einen link zu den Verkaufsunterlagen finden Sie auf der Seite „Wertpapiervergleich“ an Ende des Dokuments. Die Verkaufsunterlagen sind auch in der Sparkassen-Filiale bei ihren Beratern erhältlich.
          <br>
          <br>Datenbasis: Tagesdaten des dargestellten Zeitraums, Quelle: FWW Fundservices GmbH, Dericon GmbH
          <br>Bei der Berechnung der Wertentwicklungen werden keine kundenindividuellen Kosten wie Depotkosten oder Transaktionskosten berücksichtigt. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten.
        </div>
      </div>
      <div
          slot="raw-footer"
          class="page-block"
      >
        <div class="disclaimer-date">
          Erstellt am {{ $options.filters.date(new Date(), 'DD.MM.YYYY HH:mm') }}
        </div>
      </div>
    </document-container>

    <document-container
        :body="[]"
        :footer="[]"

        :header="[{
          type: 'Pagetitle',
          title: 'Risikobetrachtung',
          position: 'header',
          sort: 1,
          shared: true,
          }]"
        :logo="logo"
        documentType="portfolio"
        orientation="portrait"
    >
      <div
          slot="raw-body"
          class="page-block">

        <h3>Historische Häufigkeiten der Monatsrenditen</h3>
        <table class="product-table development-table" style="display: inline-table; width: 250px; margin-right: 20px">
          <thead>
          <tr>
            <th>Monatsrenditen</th>
            <th>Häufigkeit</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(value, key) in negativeReturns" :key="key">
            <td>{{ value.label }}</td>
            <td v-html="formatPercent(getDistributionValue(key))"></td>
          </tr>
          </tbody>
        </table>

        <!-- Positive Returns Table -->
        <table class="product-table development-table" style="display: inline-table; width: 250px">
          <thead>
          <tr>
            <th>Monatsrenditen</th>
            <th>Häufigkeit</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(value, key) in positiveReturns" :key="key">
            <td>{{ value.label }}</td>
            <td v-html="formatPercent(getDistributionValue(key))"></td>
          </tr>
          </tbody>
        </table>

      </div>
      <div
          slot="raw-body"
          class="page-block">

        <chart-container
            v-if="chartData"
            :chart-data="chartData.bar"
            :settings="{style: {height: 170,width: 520}}"
            chart-type="ChartPortfolioBar"
        ></chart-container>
        <div class="tiny-text" style="margin-top:12px">Betrachtungszeitraum: {{ $options.filters.date(response.figures[0].monthlyReturnStatistics.distribution.startDate) }} - {{ $options.filters.date(response.figures[0].monthlyReturnStatistics.distribution.endDate) }}</div>
        <div class="tiny-text">Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.</div>

      </div>
      <div
          slot="raw-body"
          class="page-block">

        <div style="display: inline-block; width: 250px;vertical-align: top;">
          <h3>Weitere Kennzahlen</h3>

          <table class="product-table development-table">
            <tr v-for="val in monthlyStats">
              <td>
                <strong>{{ val.label }}</strong>
              </td>
              <td v-if="!val.plain">{{ formatPercent(response.figures[0].monthlyReturnStatistics[val.path]) }}</td>
              <td v-else>{{ response.figures[0].monthlyReturnStatistics[val.path] !== null ? response.figures[0].monthlyReturnStatistics[val.path] : '—' }}</td>
            </tr>
          </table>

          <div class="tiny-text" style="margin-top:12px">Betrachtungszeitraum: {{ $options.filters.date(response.figures[0].monthlyReturnStatistics.distribution.startDate) }} - {{ $options.filters.date(response.figures[0].monthlyReturnStatistics.distribution.endDate) }}</div>
          <div class="tiny-text">Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.</div>

        </div>
        <div style="display: inline-block; width: 250px; margin-left: 20px;;vertical-align: top;">
          <h3>Erläuterung</h3>
          <p>Dargestellt werden Häufigkeiten, in denen über einen Betrachtungszeitraum von 10 Jahren bestimmte Monatsrenditen über- oder unterschritten wurden. Der Wert bei <-3% sagt beispielsweise aus, in wieviel Prozent der Fälle im Betrachtungszeitraum die Monatsrendite kleiner als -3% war. Die Kennzahlen auf der linken Seite beziehen sich auf den gleichen Betrachtungszeitraum und ebenfalls auf Monatsrenditen.</p>
        </div>
      </div>

      <div
          slot="raw-body"
          class="page-block">
        <div class="page-disclaimer">
          Transaktionskosten, Provisionen, Depotkosten und Steuern sind in der Berechnung nicht berücksichtigt und würden sich bei Berücksichtigung negativ auf die Wertentwicklung auswirken. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten. Diese Kostendarstellung erfüllt damit nicht die Anforderungen an einen aufsichtsrechtlich vorgeschriebenen Kostenausweis (ex post bzw. ex ante), den Sie rechtzeitig vor Auftragsausführung erhalten werden. Alle Fragen zu entstehenden Kosten werden Ihnen von Ihrer Sparkasse beantwortet.
          <br>Sollten für einzelne Fonds keine Kursdaten über den gesamten angezeigten Zeitraum vorhanden sein, werden diese Fonds für die Berechnung der Wertentwicklungen für die betreffenden Zeiträume nicht berücksichtigt und die Gewichtung der anderen Fonds entsprechend angepasst.
          <br>Risikohinweis: Jede Anlage in Finanzinstrumenten bzw. Vermögensanlagen ist mit Risiken verbunden. Die Anlage ist nicht garantiert, Schwankungen des Marktes können zu Kursverlusten bis hin zum Totalverlust des eingesetzten Kapitals führen. Über die speziellen Risiken des jeweiligen Finanzinstruments bzw. der Vermögensanlage informieren Sie ihre Sparkassen-Berater und die jeweiligen gesetzlich vorgeschriebenen Verkaufsunterlagen. Einen link zu den Verkaufsunterlagen finden Sie auf der Seite „Wertpapiervergleich“ an Ende des Dokuments. Die Verkaufsunterlagen sind auch in der Sparkassen-Filiale bei ihren Beratern erhältlich.
          <br>
          <br>Datenbasis: Tagesdaten des dargestellten Zeitraums, Quelle: FWW Fundservices GmbH, Dericon GmbH
          <br>Bei der Berechnung der Wertentwicklungen werden keine kundenindividuellen Kosten wie Depotkosten oder Transaktionskosten berücksichtigt. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten.
        </div>
      </div>
      <div
          slot="raw-footer"
          class="page-block"
      >
        <div class="disclaimer-date">
          Erstellt am {{ $options.filters.date(new Date(), 'DD.MM.YYYY HH:mm') }}
        </div>
      </div>
    </document-container>
    <document-container
        :body="[]"
        :footer="[]"

        :header="[{
          type: 'Pagetitle',
          title: 'Regionale Gewichtung',
          position: 'header',
          sort: 1,
          shared: true,
        }]"
        :logo="logo"
        documentType="portfolio"
        orientation="portrait"
    >
      <div
          slot="raw-body"
          class="page-block">

        <div v-for="continent in continents" :style="{top: continent.top + 'px',left: continent.left + 'px'}" class="continent">

          <chart-container
              :chart-data="getRegionChartData(continent)"
              :settings="{style: {height: 80,width: 80},}"
              chart-type="ChartDoughnut"
              style="position: absolute; z-index:50"
          ></chart-container>
          <img src="./Ellipse 51.png" style="position:absolute;left:0;top:0;"/>

          <div style="width:50px;z-index:100">
            {{ continent.name }}<br> {{ formatPercent((response.regionalDistribution[continent.key] || 0)) }}
          </div>
        </div>
        <img src="/config/dericon/images/world.png" style="max-width:100%; top: 103px; position: absolute;"/>
        <div class="page-disclaimer">
          Die Gewichtungen der einzelnen Regionen können höher sein als dargestellt, da sie auch in der globalen Allokation enthalten sind.
          <br><br> Quelle Fondsdaten: FE Fundinfo Limited
          <br> Quelle Berechnung Datenaggregation: Dericon GmbH
          <br> Die angegebene regionale Gewichtung bezieht sich auf die den Fondsstammdaten genannten Anlageregion der Fonds.
        </div>
      </div>

      <div
          slot="raw-footer"
          class="page-block"
      >
        <div class="disclaimer-date">
          Erstellt am {{ $options.filters.date(new Date(), 'DD.MM.YYYY HH:mm') }}
        </div>
      </div>
    </document-container>
    <document-container
        v-for="group in groupedProducts"
        :body="[]"

        :footer="[]"
        :header="[{
          type: 'Pagetitle',
          title: 'Wertpapiervergleich',
          position: 'header',
          sort: 1,
          shared: true,
        }]"
        :logo="logo"
        documentType="portfolio"
        orientation="portrait"
    >
      <div
          slot="raw-body"
          class="page-block"
      >
        <table class="product-table comparison-table">
          <tr>
            <th style="width:123px">
              <strong>Stammdaten</strong>
            </th>
            <th v-for="product in group" style="text-align:right;width:123px">
              <strong>{{ product.enriched.displayName }}</strong>
            </th>
          </tr>
          <tr v-for="col in response.products.structure.columns">
            <td style="width:123px">
              <strong> {{ col.label }} </strong>
              <DocTimeFrame
                  v-if="Object.keys(comparisonLabelMap).includes(col.label)"
                  :br="false"
                  :years="comparisonLabelMap[col.label]"></DocTimeFrame>
            </td>
            <tablefield
                v-for="product in group"
                :column="col"
                :product="product"
                :secondary-index="0"
                style="text-align:right;width:123px"
            ></tablefield>
          </tr>
        </table>
        <div class="tiny-text" style="margin-top: 12px;">Quelle: FWW Fundservices GmbH | Wertentwicklungen in der Vergangenheit sind kein verlässlicher Indikator für die künftige Wertentwicklung.</div>
      </div>

      <div
          slot="raw-body"
          class="page-block"
      >
        <div class="tiny-text">
          <h3>Verkaufsdokumente</h3>
          <div v-for="product in group" style="line-height: 7px">
            <strong>{{ product.enriched.displayName }}</strong>
            <br>
            <template v-for="link in product.links">
              <a :href="link.link" style="color: #000">{{ link.label }}: {{ link.link }}</a>
              <br>
            </template>
            <br>
          </div>
        </div>
      </div>

      <div
          slot="raw-body"
          class="page-block">
        <div class="page-disclaimer">
          Transaktionskosten, Provisionen, Depotkosten und Steuern sind in der Berechnung nicht berücksichtigt und würden sich bei Berücksichtigung negativ auf die Wertentwicklung auswirken. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten. Diese Kostendarstellung erfüllt damit nicht die Anforderungen an einen aufsichtsrechtlich vorgeschriebenen Kostenausweis (ex post bzw. ex ante), den Sie rechtzeitig vor Auftragsausführung erhalten werden. Alle Fragen zu entstehenden Kosten werden Ihnen von Ihrer Sparkasse beantwortet.
          <br>Sollten für einzelne Fonds keine Kursdaten über den gesamten angezeigten Zeitraum vorhanden sein, werden diese Fonds für die Berechnung der Wertentwicklungen für die betreffenden Zeiträume nicht berücksichtigt und die Gewichtung der anderen Fonds entsprechend angepasst.
          <br>Risikohinweis: Jede Anlage in Finanzinstrumenten bzw. Vermögensanlagen ist mit Risiken verbunden. Die Anlage ist nicht garantiert, Schwankungen des Marktes können zu Kursverlusten bis hin zum Totalverlust des eingesetzten Kapitals führen. Über die speziellen Risiken des jeweiligen Finanzinstruments bzw. der Vermögensanlage informieren Sie ihre Sparkassen-Berater und die jeweiligen gesetzlich vorgeschriebenen Verkaufsunterlagen. Einen link zu den Verkaufsunterlagen finden Sie auf der Seite „Wertpapiervergleich“ an Ende des Dokuments. Die Verkaufsunterlagen sind auch in der Sparkassen-Filiale bei ihren Beratern erhältlich.
          <br>
          <br>Datenbasis: Tagesdaten des dargestellten Zeitraums, Quelle: FWW Fundservices GmbH, Dericon GmbH
          <br>Bei der Berechnung der Wertentwicklungen werden keine kundenindividuellen Kosten wie Depotkosten oder Transaktionskosten berücksichtigt. Bitte beachten Sie hier das Preisverzeichnis Ihrer depotführenden Stelle bzw. Ihrer Sparkasse. Lediglich die auf Fondsebene anfallenden laufenden Kosten sind in den Wertentwicklungen enthalten.
        </div>
      </div>
      <div
          slot="raw-footer"
          class="page-block"
      >
        <div class="disclaimer-date">
          Erstellt am {{ $options.filters.date(new Date(), 'DD.MM.YYYY HH:mm') }}
        </div>
      </div>
    </document-container>
    <document-container
        :body="[]"

        :footer="[]"
        :header="[{
          type: 'Pagetitle',
          title: 'Rechtliche Hinweise',
          position: 'header',
          sort: 1,
          shared: true,
        }]"
        :logo="logo"
        documentType="portfolio"
        orientation="portrait"
    >
      <div
          slot="raw-body"
          class="page-block"
      >
        <span style="text-decoration: underline">Bitte beachten Sie:</span>
        <br><br>Bei den in dieser Präsentation dargestellten Eckpunkten zu Zielvorgaben oder Anforderungen an eine Vermögensanlage und dem dargestellten Anlage- bzw. Umsetzungsvorschlag handelt es sich um Angaben und Vorgaben der Sie beratenden Sparkasse und deren Mitarbeitenden. Enthaltene Darstellungen, insb. Berechnungen oder Simulationen aus den benannten Quellen, dienen ausschließlich als ergänzende Zusatzinformation und stellen keine Anlageberatung durch diese Quellen dar.
        <br>Diese Präsentation enthält nicht alle für den Erwerb etwaiger in der Präsentation dargestellter Finanzinstrumente relevanten Informationen und dient lediglich zu Informationszwecken des jeweiligen Empfängers. Eine detaillierte Beschreibung der Risiken ist dem jeweiligen Verkaufsprospekt (Investmentfonds), Wertpapierprospekt (Inhaberschuldverschreibungen) oder den Sonderbedingungen (Vermögensverwaltungsprodukte) zu entnehmen. Die Darstellung der Finanzinstrumente in dieser Präsentation stellt weder ein Angebot noch eine Anlageberatung oder eine Anlageempfehlung zum Erwerb oder Verkauf von Finanzinstrumenten / Vermögensverwaltungen dar. Die Darstellung einer historischen Entwicklung von Finanzinstrumenten erfolgt auf Euro-Basis, sofern keine anderen Angaben gemacht werden. Diese Präsentation verpflichtet die Sparkasse nicht zur Abgabe eines Angebots oder zum Geschäftsabschluss gegenüber dem Empfänger. Die hierin enthaltenen Meinungen werden ohne Berücksichtigung der Umstände, Ziele oder Bedürfnisse des jeweiligen Empfängers abgegeben. Die Präsentation kann eine individuelle Beratung des Empfängers (z. B. durch eine Bank oder einen Berater) nicht ersetzen.
        <br>Diese Präsentation wurde mit Sorgfalt erstellt. Teilweise werden in dieser Präsentation Meinungsaussagen getroffen. Diese Meinungsaussagen geben die aktuelle Einschätzung der Sparkasse zum Zeitpunkt der Erstellung dieser Präsentation wieder. Die Einschätzung kann sich jederzeit ohne Ankündigung ändern. Die verwendeten Daten stammen teilweise aus Drittquellen, die die Sparkasse nach bestem Wissen als vertrauenswürdig erachtet. Die Sparkasse übernimmt jedoch keine Gewähr für die Vollständigkeit, Aktualität und Richtigkeit der in dieser Präsentation gemachten Angaben und haftet nicht für etwaige Schäden oder Aufwendungen, die aus einem Vertrauen auf die Vollständigkeit, Aktualität und Richtigkeit der aus Drittquellen stammenden Daten resultiert.
        <br>Etwaige in dieser Präsentation erwähnten Finanzinstrumente können mit Risiken verbunden sein, die schwer abzuschätzen und in die Evaluation einer Anlageentscheidung einzubeziehen sind. Die Sparkasse ist bereit, Kunden auf Wunsch weitere Informationen zu den Risiken spezifischer Anlagen zu liefern.
        <br>Auf besondere Verkaufsbeschränkungen und Vertriebsvorschriften in den verschiedenen Rechtsordnungen wird hingewiesen. Insbesondere darf das hierin beschriebene Finanzinstrument weder innerhalb der Vereinigten Staaten von Amerika noch an beziehungsweise zugunsten von US-Personen zum Kauf oder Verkauf angeboten werden.
        <br>Allein verbindliche Grundlage für den Erwerb von Investmentfonds sind die jeweiligen Basisinformationsblätter, die jeweiligen Verkaufsprospekte und die jeweiligen Berichte. Diese erhalten Sie bei Ihrer Sparkasse.
        <br>
        <br>
        <div v-html="customDisclaimer"></div>
        <br>
        <br>Die Verwaltungsgesellschaft des Investmentfonds kann jederzeit beschließen, den Vertrieb einzustellen.
        <br>
        <br>© {{ $options.filters.date(new Date(), 'YYYY') }} Dericon GmbH, Mainzer Landstraße 41–45, 60329 Frankfurt am Main
      </div>

      <div
          slot="raw-footer"
          class="page-block"
      >
        <div class="disclaimer-date">
          Erstellt am {{ $options.filters.date(new Date(), 'DD.MM.YYYY HH:mm') }}
        </div>
      </div>
    </document-container>

  </div>
</template>

<script>
import DocumentContainer
  from "../document/DocumentContainer.vue"
import Tablefield
  from "../table-field/FieldContainer.vue"
import {
  EventBus,
} from "../../service/EventBus"
import ChartContainer
  from "../chart/ChartContainer.vue"

import DocTimeFrame
  from "./DocTimeFrame.vue"
import Pagebreak
  from "../block/BlockPagebreak.vue"
import ProductService
  from "../../service/ProductService"
import TokenService
  from "../../service/TokenService"

export default {
  name: "Portfolio",
  components: {
    Pagebreak,
    DocTimeFrame,
    ChartContainer,
    Tablefield,
    DocumentContainer,

  },
  props: ['environment', 'appInstanceId', 'moduleId', 'simulationId', 'figuresId'],
  data() {
    return {
      negativeReturns: {
        LT_MINUS_5: {label: '<-5 %'},
        LT_MINUS_4: {label: '<-4 %'},
        LT_MINUS_3: {label: '<-3 %'},
        LT_MINUS_2: {label: '<-2 %'},
        LT_MINUS_1: {label: '<-1 %'},
        LT_0: {label: '<0 %'},
      },
      positiveReturns: {
        GTE_0: {label: '>0 %'},
        GT_1: {label: '>1 %'},
        GT_2: {label: '>2 %'},
        GT_3: {label: '>3 %'},
        GT_4: {label: '>4 %'},
        GT_5: {label: '>5 %'},
      },
      comparisonLabelMap: {
        'Aktueller Kurs': 'TODAY',
        'Wertentwicklung (1 Jahr)': 'ONE_YEAR',
        'Wertentwicklung (3 Jahre)': 'THREE_YEARS',
        'Wertentwicklung (5 Jahre)': 'FIVE_YEARS',
        'Volatilität (1 Jahr)': 'ONE_YEAR',
        'Volatilität (3 Jahre)': 'THREE_YEARS',
      },
      response: null,
      token: null,
      pageCounter: 0,
      colors: [
        "#ff3030",
        "#20cdbc",
        "#ff8c00",
        "#a2d200",
        "#6098f8",
        "#009864",
        "#ffd700",
        "#c1cdcd",
        "#d46deb",
        "#353535",
        "#ac2e15",
        "#f2c289",
        "#809740",
        "#74e3d5",
        "#5458b7",
        "#47bd78",
        "#b99b00",
        "#4a8e8e",
        "#a4618b",
        "#0084d1",
        "#9810fa",
        "#e7000b",
        "#432dd7",
        "#c6005c",
        "#bb4d00",
        "#007a55",
        "#1447e6",
        "#a800b7",
        "#ca3500",
        "#497d00",
        "#e5e5e5",
      ],
      groups: {
        SUB_GROUP: {
          CORE: 'Kernanlage',
          SATELLITE: 'Satellitenanlage',
        },
      },
      monthlyStats: [
        {
          path: 'worstMonth',
          label: 'Schlechtester Monat',
        },
        {
          path: 'bestMonth',
          label: 'Bester Monat',
        },
        {
          path: 'averageReturn',
          label: 'Durchschnittlicher Monat',
        },
        {
          path: 'longestPeriodOfNegativeReturns',
          label: 'Längste Dauer negative Monate',
          plain: true,
        },
        {
          path: 'returnOfLongestNegativePeriod',
          label: 'Summe negative Rendite in Folge',
        },
        {
          path: 'maxDrawdown',
          label: 'Max. Verlust von Spitze zu Tief',
        },
        {
          path: 'timeToRecoverInMonths',
          label: 'Monate Aufholung',
          plain: true,
        },
      ],
      continents: [
        {
          name: 'Global',
          key: 'OTHER',
          top: 0,
          left: 388,
        },
        {
          name: 'Nordamerika',
          key: 'NORTH_AMERICA',
          top: 115,
          left: 7,
        },
        {
          name: 'Europa',
          key: 'EUROPE',
          top: 115,
          left: 199,
        },
        {
          name: 'Asien',
          key: 'ASIA',
          top: 115,
          left: 310,
        },
        {
          name: 'Südamerika',
          key: 'SOUTH_AMERICA',
          top: 245,
          left: 58,
        },
        {
          name: 'Afrika',
          key: 'AFRIKA',
          top: 245,
          left: 194,
        },
        {
          name: 'Australien & Pazifik',
          key: 'AUSTRALIA_PACIFIC',
          top: 245,
          left: 388,
        },
      ],
      performanceMap: {
        YTD: 'Jahresanfang',
        ONE_YEAR: '1 Jahr',
        THREE_YEARS: '3 Jahre',
        FIVE_YEARS: '5 Jahre',
        TEN_YEARS: '10 Jahre',
      },
      maxDrawdownMap: {
        relativeLoss: 'Verlust',
        lossPeriodInDays: 'Zeitraum',
        periodStart: 'Start',
        periodEnd: 'Ende',
        timeToRecoverInDays: 'Dauer der Wertaufholung',
      },
    }
  },
  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: '/config/sparkasse/style/shortlist.css',
        },
      ]
    },
  },
  methods: {
    isValidNumber(value) {
      return value !== null &&
          value !== undefined &&
          !isNaN(value) &&
          isFinite(value)
    },

    getDistributionValue(key) {
      if (!this.response ||
          !this.response.figures ||
          !this.response.figures[0] ||
          !this.response.figures[0].monthlyReturnStatistics ||
          !this.response.figures[0].monthlyReturnStatistics.distribution) {
        return 0
      }
      const value = this.response.figures[0].monthlyReturnStatistics.distribution.distributions[key] || 0
      return this.isValidNumber(value) ? value : 0
    },
    formatPercent(number, digits) {
      if (!this.isValidNumber(number)) {
        return '—'
      }
      return (number * 100).toLocaleString('de-DE', {
        minimumIntegerDigits: 1,
        minimumFractionDigits: digits !== undefined ? digits : 2,
        maximumFractionDigits: digits !== undefined ? digits : 2,
      }) + ' %'
    },
    formatDays(value) {
      if (!this.isValidNumber(value)) {
        return '—'
      }
      return value + ' Tage'
    },
    getGroupName(type, name) {
      switch (type) {
        case 'DEPOT':
          return 'Portfolio'
        case 'SUB_GROUP':
          return this.groups[type][name]
        case 'BENCHMARK':
          return name
      }
    },
    getLineColor(id) {
      let idArray = id.split("|")
      switch (idArray[0]) {

        case 'DEPOT':
          return this.colors[0]
        case 'BENCHMARK':
          return this.colors[1]
        case 'SUB_GROUP':
          switch (idArray[idArray.length - 3]) {
            case 'CORE':
              return this.colors[1]
            case 'SATELLITE':
              return this.colors[2]
            default:
              return this.colors[3]
          }
        default:
          return this.colors[2]
      }

    },
    getRegionChartData(continent) {
      return {
        datasets: [
          {
            borderWidth: 0,
            backgroundColor: ['#EE0000', '#e5e5e5'],
            data: [
              this.response.regionalDistribution[continent.key] || 0,
              1 - (this.response.regionalDistribution[continent.key] || 0),
            ],
          },
        ],
      }
    },
  },
  mounted() {
    EventBus.$on('pageCounter', amount => {
      this.pageCounter += amount
    })
  },
  computed: {
    logo() {
      return '/config/' + this.environment + '/images/logo.png'
    },
    portfolioFigures() {
      return this.response.figures.filter(el => el.id.type === 'DEPOT')
    },
    satelliteFigures() {
      return this.response.figures.filter(el => el.id.type === 'SUB_GROUP' && el.id.name === 'SATELLITE')
    },
    coreFigures() {
      return this.response.figures.filter(el => el.id.type === 'SUB_GROUP' && el.id.name === 'CORE')
    },
    benchmarkFigures() {
      return this.response.figures.filter(el => el.id.type === 'BENCHMARK')
    },
    productFigures() {
      return this.response.figures.filter(el => el.id.type === 'PRODUCT')
    },
    groupedProducts() {
      let groupedProducts = [[]]
      let index = 0
      this.response.products.data.map(product => {
        if (groupedProducts[index].length === 3) {
          index++
          groupedProducts.push([])
        }
        groupedProducts[index].push(product)
      })
      return groupedProducts
    },
    developmentChart() {
      if (this.response) {
        return {
          datasets: [...this.response.portfolioAndSubGroupChart.chart.seriesList.map((series, index) => {
            return {
              borderColor: this.getLineColor(series.label),
              fill: false,
              lineTension: 0,
              borderJoinStyle: 'round',
              backgroundColor: 'rgba(0,0,0,0)',
              pointRadius: 0,
              data: series.values,
              borderWidth: 4,
            }
          })],
        }
      }
    },
    benchmarkChart() {
      if (this.response) {
        return {
          datasets: [...this.response.portfolioAndBenchmarkChart.chart.seriesList.map((series, index) => {
            return {
              borderColor: this.getLineColor(series.label),
              fill: false,
              lineTension: 0,
              borderJoinStyle: 'round',
              backgroundColor: 'rgba(0,0,0,0)',
              pointRadius: 0,
              data: series.values,
              borderWidth: 4,
            }
          })],
        }
      }
    },
    reducedPortfolioAndBenchmarkChart() {
      if (this.response && this.response.reducedPortfolioAndBenchmarkChart) {
        return {
          datasets: [...this.response.reducedPortfolioAndBenchmarkChart.chart.seriesList.map((series, index) => {
            return {
              borderColor: this.getLineColor(series.label),
              fill: false,
              lineTension: 0,
              borderJoinStyle: 'round',
              backgroundColor: 'rgba(0,0,0,0)',
              pointRadius: 0,
              data: series.values,
              borderWidth: 4,
            }
          })],
        }
      }
    },
    chartData() {
      if (this.response !== null) {
        return {
          bar: {
            labels: [
              '<-5 %',
              '<-4 %',
              '<-3 %',
              '<-2 %',
              '<-1 %',
              '<0 %',
              '>0 %',
              '>1 %',
              '>2 %',
              '>3 %',
              '>4 %',
              '>5 %',
            ],
            datasets: [{
              barThickness: 40,
              backgroundColor: '#EE0000',
              data: [...Object.values(this.response.figures[0].monthlyReturnStatistics.distribution.distributions).map(el => el * 100)],
            }],
          },
          donut1: {
            datasets: [
              {
                borderWidth: 0,
                backgroundColor: this.colors,
                data: [...Object.values(this.response.coreInvestmentDistribution), ...Object.values(this.response.satelliteInvestmentDistribution)],
              },
            ],
          },
          donut2: {
            datasets: [
              {
                borderWidth: 0,
                backgroundColor: this.colors,
                data: [...Object.values(this.response.assetDistribution)],
              },
            ],
          },
          donut3: {
            datasets: [
              {
                borderWidth: 0,
                backgroundColor: this.colors,
                data: [...Object.values(this.response.currencyDistribution)],
              },
            ],
          },
        }
      }
    },
    customDisclaimer() {
      switch (this.environment) {
        case 's-abmil':
          return 'Ihre Sparkasse hat eine Beschwerdestelle eingerichtet und Maßnahmen zum Beschwerdemanagement vorgesehen. <a href="https://www.s-abmil.de/content/dam/myif/spk-aschaffenburg/work/dokumente/pdf/allgemein/beschwerdemanagementgrundsaetze.pdf?stref=textbox">Hier finden Sie die Beschwerdemanagement-Grundsätze</a>'
        case 'dericon':
        case 'test':
          return ''
        case 'sparkasse':
          return ''
        case 'sparkasse-augsburg':
          return 'Detaillierte Informationen zu Beschwerden sowie zur zuständigen Schlichtungsstelle einschließlich der Kontaktdaten finden Sie auf der folgenden Webseite: https://www.sska.de/de/home/toolbar/impressum.html'
        case 'bison':
          return ''
        default:
          return ''
      }
    },
  },
  async created() {

    if (!this.$route.query.token) {
      this.token = await TokenService.checkToken()
    } else {
      this.token = this.$route.query.token
    }
    // this.response = dummy
    // this.response.portfolioAndSubGroupChart = chart.data
    // this.response.portfolioAndBenchmarkChart = benchmark.data

    ProductService.getPortfolio(this.appInstanceId, this.moduleId, this.simulationId, this.figuresId, this.token).then(res => {
      this.response = res.data.data
    })

  },
}
</script>

<style lang="scss">


.document.portfolio {
  font-size: 7.5px;

  .page {
    padding: 25px 25px 25px 50px !important;
    width: 595px !important;
    height: 842px !important;

  }

  .page-block {
    padding-bottom: 15px;
  }

  header, footer, .page-body {
    width: 520px !important;
    overflow: visible !important;
  }

  strong {
    color: #000
  }

  header {
    height: 40px !important;
  }

  .header {
    margin-top: 0 !important;
    position: absolute;

  }

  .page-body {
    height: 752px !important;
    width: 520px !important;
    position: absolute;
    top: 65px
  }

  footer {
    overflow: visible !important;
    margin-bottom: 0 !important;
    bottom: 25px !important;

    .page-number {
      bottom: -2px !important;
      left: initial !important;
      right: 0;
      padding-top: 0 !important;
      font-size: 7.5px !important;
      position: absolute;
    }
  }

  .product-table {
    font-size: 8px;
    line-height: 10px;

    td {
      padding: 3px 0;
    }

    td:not(:first-child),
    th:not(:first-child) {
      padding-right: 0;
      padding-left: 11px;
    }

    td:first-child,
    th:first-child {
      padding-right: 0;
      padding-left: 0;
    }
  }

  .heading {

    h1 {
      position: absolute;
      top: 283px;
      color: #000 !important;
      font-size: 30px !important;
      font-weight: 400 !important;
      line-height: 100%;
      margin: 0 !important;
    }

    h2 {
      top: 329px;
      position: absolute;
    }
  }

  .page-disclaimer {
    /* */

    position: absolute;
    bottom: 21px;
    margin: 0 auto;
    width: 520px;

    font-style: normal;
    font-weight: 400;
    font-size: 6.5px;
    line-height: 8px;

    color: #000000;


    /* Inside auto layout */

  }

  .disclaimer-date {
    position: absolute;
    bottom: 0;
    left: 0;
    margin: 0 auto;
    width: 520px;

    font-style: normal;
    font-weight: 400;
    font-size: 7.5px;
    line-height: 8px;

    color: #000000;
  }

  h3 {
    font-weight: 600 !important;
    font-size: 10px !important;
    color: #000 !important;
    margin-bottom: 8px !important;
    margin-top: 0 !important;
  }

  .bottom-text {
    position: absolute;
    font-weight: 400;
    font-size: 8px;
    line-height: 100%;
    bottom: -15px;
  }

  .logo {
    height: 28px;
    top: 25px !important;
    right: 25px;
  }

  .page-title {
    margin-top: -2px;
  }

  .page-title h1,
  h2 {
    font-weight: 700 !important;
    font-size: 16px;
    line-height: 100%;
    margin: 0 !important;
    text-transform: uppercase;
  }

  .continent {
    z-index: 100;
    text-align: center;
    width: 80px;
    height: 80px;
    font-weight: 600;
    font-size: 8px;
    line-height: 1.3;
    letter-spacing: 0;
    position: absolute;
    display: flex;
    align-items: center;
    justify-items: center;
    justify-content: center;
  }

  table {
    margin-bottom: 0 !important;

    tr {
      td, th {
        border: none !important;
        color: #000 !important;
      }
    }
  }

  .allocation-table {

    & > tbody > tr > td {
      padding: 5px 0;
    }

    .allocation-heading > td {
      font-size: 8px !important;
      font-weight: 700;
    }

    tbody > tr > td td {
      border: none !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
      padding-top: 0 !important;
      padding-bottom: 10px;
      font-size: 8px;

      &:last-child {
        text-align: right;
        min-width: 40px;
      }
    }

    .chartContainer {
      position: relative;
      left: 39px
    }
  }

  .dot {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    display: inline-block;
    vertical-align: text-bottom;
    margin-right: 5px;
  }

  .development-table {

    tr:not(:first-child) > td {
      border-top: 1px solid #D4D4D4 !important;
    }

    td:not(:first-child), th:not(:first-child) {
      text-align: right;
    }
  }

  .comparison-table {
    width: 520px !important;

    tr > td {
      border-top: 1px solid #D4D4D4 !important;
    }
  }

  .header-disclaimer {
    position: absolute;
    left: 50px;
    top: 25px;
    font-size: 7.5px;
  }

  .tiny-text {
    font-size: 6.5px;
    line-height: 7px;

  }
}

</style>



// WEBPACK FOOTER //
// Portfolio.vue?4a748e68